const __request = require(`../__request/__request_contentType_json`);

// 国际机票列表
const internationalList = (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/flight/international/buyer/white/flight/list',
    data:data
  }

  return __request(pParameter)
}
export default internationalList


